import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";

export const getBase64GeneratePdfSuratPersetujuanMaster = async (
    requestId?: string,
    fileName?: string
) => {
  const dataAPI = await HttpService.post(
    ApiService.alesaForm.getBase64GeneratePdf,
    JSON.stringify({
        RequestID: requestId,
        FileName: fileName
    })
  );

  return dataAPI.data.data;
};
